import { axios } from '../index'

const deleteShareFolderGroupPermission = (
  folderId: string,
  groupId: string,
  personaId: string,
  permissionName: string
) => {
  return axios.delete(
    `/v1/group/${groupId}/folders/${folderId}/personas/${personaId}/permissions/${permissionName}`,
    {
      data: {
        folderId: folderId,
        groupId: groupId,
        permissionName: permissionName,
        personaId: personaId
      }
    }
  )
}

export default deleteShareFolderGroupPermission
